import { useCallback } from 'react';
import { trackAnalytics } from 'common/components/CopyMagic/shared/dataHelpers';
import { useUiResourceContext, useConfigContext } from 'common/components/CopyMagic/contexts';

const useTrackFeedbackSentiment = () => {
  const { productEvents } = useConfigContext();
  const { feedbackSentiment } = useUiResourceContext();
  const feedbackToInteger = feedbackSentiment.positive === true ? 1 : 2;

  const trackCallback = useCallback(
    ({ contentId }: { contentId: string }) => {
      if (feedbackSentiment.positive === null) return;

      const trackProductAnalytics = trackAnalytics(productEvents);

      trackProductAnalytics('Rated', {
        'Feedback Sentiment Enum': feedbackToInteger,
        'Content ID': contentId,
      });
    },
    [feedbackSentiment.positive, feedbackToInteger, productEvents],
  );

  return trackCallback;
};

export default useTrackFeedbackSentiment;
